import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Server may inject SEO content into #root for crawlers (AdSense, Googlebot).
// React replaces it on mount. Crawlers see the content in the initial HTML source.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
